<template>
  <Teleport to="body">
    <div class="modal-backdrop" role="dialog" aria-modal="true">
      <div class="modal-panel" :class="panelClass">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { computed, defineComponent, onBeforeUnmount, onMounted, PropType } from "vue";

const modalSizeClasses = {
  sm: "modal-panel--sm",
  md: "modal-panel--md",
  lg: "modal-panel--lg",
  history: "modal-panel--history",
  xl: "modal-panel--xl",
};

type ModalSize = keyof typeof modalSizeClasses;

export default defineComponent({
  emits: ["close"],
  props: {
    size: {
      type: String as PropType<ModalSize>,
      default: "md",
      validator: (value: string) =>
        Object.prototype.hasOwnProperty.call(modalSizeClasses, value),
    },
  },
  setup(props, { emit }) {
    const panelClass = computed(() => modalSizeClasses[props.size]);

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      emit("close");
    };

    onMounted(() => window.addEventListener("keydown", closeOnEscape));
    onBeforeUnmount(() => window.removeEventListener("keydown", closeOnEscape));

    return {
      panelClass,
    };
  },
});
</script>
